import { useState } from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/util';
import {
  ACTIVE_LISTING,
  PENDING_LISTING,
  DRAFT_LISTING,
  ARCHIVED_LISTING,
  SENT_FOR_AMENDMENT,
} from '../../../../utils/constants';

import ProductFilterContainer from '../../../../containers/common/product-filter/ProductFilter.container';
import BuyerListing from '../../../common/listing/buyer-listing/BuyerListing';
import Button from '../../../common/button/Button';
import Tooltip from '../../../common/tooltip/ToolTip';

import { ReactComponent as ShareIcon } from '../../../../resources/icons/share.svg';

import './my-buyer-listings.scss';

const MyBuyerListings = ({ listings, applyFilters, buzzProduct, currencyCode }) => {
  const [miniView, setMiniView] = useState(true);

  const navigate = useNavigate();

  const renderMiniViewHeaders = () => (
    <section className="my-buyer-listings__mini-headers">
      <p>Product</p>
      <p>{currencyCode} Price/Product Unit</p>
      <p>Available Date</p>
      <span />
    </section>
  );

  const renderListings = (statuses) => {
    const filteredListings = listings.filter((listing) => statuses.includes(listing.status.toLowerCase()));

    if (filteredListings.length === 0) {
      return <p className="my-buyer-listings__no-listings">No {statuses[0].split(' ')[0]} Listings</p>;
    }

    return (
      <>
        {miniView && renderMiniViewHeaders()}
        {filteredListings.map((listing) => {
          const actions = (
            <div className={getClassNames('my-buyer-listings__buttons', { mini: miniView })}>
              <Button onClick={() => navigate(`/shop/upload-buyer-listing/${listing.productExternalReference}`)}>
                Edit Listing
              </Button>
              {listing.status === ACTIVE_LISTING && (
                <div className="my-buyer-listings__buzz-container">
                  <div className="my-buyer-listings__tooltip">
                    <Tooltip text="Promote your Buyer Listing on the Market Buzz." maxWidth={400} toolTipLeft={true} />
                  </div>
                  <Button onClick={() => buzzProduct(listing)}>
                    Buzz This
                    <ShareIcon />
                  </Button>
                </div>
              )}
            </div>
          );

          return (
            <BuyerListing key={listing.productExternalReference} listing={listing} actions={actions} mini={miniView} />
          );
        })}
      </>
    );
  };

  return (
    <section className="my-buyer-listings" data-testid="my-buyer-listings">
      <ProductFilterContainer onApplyFiltersClick={applyFilters} />

      <section className="my-buyer-listings__cards">
        <section className="my-buyer-listings__card">
          <div className="my-buyer-listings__card__header">
            <h1 className="my-buyer-listings__card__header-text">Active Listings</h1>
            <div className={getClassNames('my-buyer-listings__card__header-buttons', { mini: miniView })}>
              <button onClick={() => setMiniView(!miniView)}>Switch View</button>
              <button onClick={() => navigate('/shop/upload-buyer-listing')}>
                <span />
                Upload New
              </button>
            </div>
          </div>
          {renderListings([ACTIVE_LISTING])}
        </section>

        <section className="my-buyer-listings__card">
          <h1 className="my-buyer-listings__card__header-text">Pending Listings</h1>
          {renderListings([PENDING_LISTING, SENT_FOR_AMENDMENT])}
        </section>

        <section className="my-buyer-listings__card">
          <h1 className="my-buyer-listings__card__header-text">Draft Listings</h1>
          {renderListings([DRAFT_LISTING])}
        </section>

        <section className="my-buyer-listings__card">
          <h1 className="my-buyer-listings__card__header-text">Archived Listings</h1>
          {renderListings([ARCHIVED_LISTING])}
        </section>
      </section>
    </section>
  );
};

MyBuyerListings.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape({})),
  applyFilters: PropTypes.func.isRequired,
  buzzProduct: PropTypes.func.isRequired,
  currencyCode: PropTypes.string.isRequired,
};

MyBuyerListings.defaultProps = {
  listings: [],
};

export default MyBuyerListings;
